import React, { useState } from 'react';

/**
 * Team logo IDs from api-football / various CDN sources.
 * Using api-football CDN which is publicly accessible.
 * Format: https://media.api-sports.io/football/teams/{id}.png
 */
const TEAM_LOGO_IDS = {
  // Football clubs — api-football IDs
  'Manchester City':  50,
  'Arsenal':          42,
  'PSG':              85,
  'Marseille':        81,
  'Real Madrid':      541,
  'Bayern Munich':    157,
  'Barcelona':        529,
  'Atletico Madrid':  530,
  'Dortmund':         165,
  'Leverkusen':       168,
  'Inter Milan':      505,
  'Juventus':         496,
  'Lyon':             80,
  'Monaco':           91,
  'RB Leipzig':       173,
  'Chelsea':          49,
  'Liverpool':        40,
  'Manchester United':33,
  'Tottenham':        47,
  'AC Milan':         489,
  'Roma':             497,
  'Napoli':           492,
  'Sevilla':          536,
  'Valencia':         532,
  'Ajax':             194,
  'Porto':            212,
  'Benfica':          211,
};

// Color schemes for fallback initials
const TEAM_COLORS = {
  'Manchester City':  { bg: '#6CABDD', text: '#fff' },
  'Arsenal':          { bg: '#EF0107', text: '#fff' },
  'PSG':              { bg: '#004170', text: '#fff' },
  'Marseille':        { bg: '#2FAEE0', text: '#fff' },
  'Real Madrid':      { bg: '#FEBE10', text: '#fff' },
  'Bayern Munich':    { bg: '#DC052D', text: '#fff' },
  'Barcelona':        { bg: '#A50044', text: '#fff' },
  'Atletico Madrid':  { bg: '#CE3524', text: '#fff' },
  'Dortmund':         { bg: '#FDE100', text: '#000' },
  'Leverkusen':       { bg: '#E32221', text: '#fff' },
  'Inter Milan':      { bg: '#010E80', text: '#fff' },
  'Juventus':         { bg: '#1D1D1B', text: '#fff' },
  'Lyon':             { bg: '#1E3461', text: '#fff' },
  'Monaco':           { bg: '#D4011D', text: '#fff' },
  'RB Leipzig':       { bg: '#DD0741', text: '#fff' },
  'Lakers':           { bg: '#552583', text: '#FDB927' },
  'Celtics':          { bg: '#007A33', text: '#fff' },
  'Warriors':         { bg: '#1D428A', text: '#FFC72C' },
  'Nets':             { bg: '#000000', text: '#fff' },
  'Djokovic':         { bg: '#1565C0', text: '#fff' },
  'Alcaraz':          { bg: '#C62828', text: '#fff' },
  'Nadal':            { bg: '#F9A825', text: '#fff' },
  'Medvedev':         { bg: '#283593', text: '#fff' },
  'Natus Vincere':    { bg: '#F7D000', text: '#000' },
  'Astralis':         { bg: '#E8422E', text: '#fff' },
};

function getInitials(name) {
  const words = name.trim().split(' ');
  if (words.length === 1) return words[0].substring(0, 2).toUpperCase();
  return (words[0][0] + words[words.length - 1][0]).toUpperCase();
}

export default function TeamLogo({ team, size = 32, sport = 'Football' }) {
  const [imgError, setImgError] = useState(false);

  const logoId = TEAM_LOGO_IDS[team];
  const colors = TEAM_COLORS[team] || { bg: '#1db954', text: '#fff' };
  const initials = getInitials(team);

  const logoUrl = logoId
    ? `https://media.api-sports.io/football/teams/${logoId}.png`
    : null;

  const style = {
    width: size,
    height: size,
    borderRadius: '50%',
    objectFit: 'contain',
    background: '#fff',
    padding: 2,
    flexShrink: 0,
  };

  const fallbackStyle = {
    width: size,
    height: size,
    borderRadius: '50%',
    background: colors.bg,
    color: colors.text,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: size * 0.35,
    fontWeight: 800,
    flexShrink: 0,
    letterSpacing: '-0.5px',
    fontFamily: 'Inter, sans-serif',
  };

  if (!logoUrl || imgError) {
    return <div style={fallbackStyle}>{initials}</div>;
  }

  return (
    <img
      src={logoUrl}
      alt={team}
      style={style}
      onError={() => setImgError(true)}
    />
  );
}
